// import React, { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Thumbs, EffectFade } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/autoplay";
// import "swiper/css/thumbs";
// import "swiper/css/effect-fade";

// const testimonials = [
//   {
//     avatar: "/img/testimonial/avater-1-1.jpg",
//     quoteImg: "/img/shape/quote1.png",
//     rating: 3,
//     name: "Lisa Smith",
//     designation: "Developer",
//     text:
//       "Lorem gfb dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation nim vengiam, quis ullamco.",
//   },
//   {
//     avatar: "/img/testimonial/avater-1-2.jpg",
//     quoteImg: "/img/shape/quote1.png",
//     rating: 4,
//     name: "Rodja Heartmann",
//     designation: "CEO, Vecuro",
//     text:
//       "Lorem ipsum dolor bfx  amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation nim vengiam, quis ullamco.",
//   },
//   {
//     avatar: "/img/testimonial/avater-1-3.jpg",
//     quoteImg: "/img/shape/quote1.png",
//     rating: 3,
//     name: "Rodja Heartmann",
//     designation: "CEO, Vecuro",
//     text:
//       "Lorem ipsum htfg sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation nim vengiam, quis ullamco.",
//   },
//   {
//     avatar: "/img/testimonial/avater-1-4.jpg",
//     quoteImg: "/img/shape/quote1.png",
//     rating: 5,
//     name: "Rodja Heartmann",
//     designation: "CEO, Vecuro",
//     text:
//       "Lorem ipsum dolor vd amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation nim vengiam, quis ullamco.",
//   },
// ];

// const TestimonialSection = () => {
//   const [thumbsSwiper, setThumbsSwiper] = useState(null);

//   return (
//     <section
//       className="space testimonial-style1"
//       data-bg-src="/img/bg/testimonial-bg.jpg"
//       style={{
//         backgroundImage: "url('/img/bg/testimonial-bg.jpg')",
//         backgroundRepeat: "no-repeat",
//         backgroundPosition: "center",
//         backgroundSize: "cover",
//       }}
//     >
//       <div className="container">
//         <div className="row justify-content-between align-items-center">
//           <div className="col-xxl-5 col-xl-5">
//             <div className="title-area">
//               <span className="sec-subtitle">Go & Discover</span>
//               <h2 className="sec-title h1">What’s Our Client’s Words</h2>
//               <p className="sec-text">
//                 Curabitur aliquet quam id dui posuere blandit. Vivamus magna
//                 justo, lacinia eget consectetur sed, convgallis at tellus.
//               </p>
//               <a href="contact.html" className="vs-btn style3">
//                 View More
//               </a>
//             </div>
//           </div>

//           <div className="col-xxl-6 col-xl-7">
//             <div className="testi-style1">
//               {/* === Avatars (thumbs) === */}
//               <div className="testi-avaters vs-slider-tab">
//                 <Swiper
//                   onSwiper={setThumbsSwiper}
//                   watchSlidesProgress
//                   spaceBetween={10}
//                   slidesPerView={4}
//                   modules={[Thumbs]}
//                   // keep classes the theme expects:
//                   className="testiAvatars mb-4"
//                 >
//                   {testimonials.map(({ avatar }, idx) => (
//                     <SwiperSlide key={idx}>
//                       {/* keep .tab-btn and initial .active on first like original */}
//                       <button
//                         className={`tab-btn${idx === 0 ? " active" : ""}`}
//                         type="button"
//                       >
//                         <img src={avatar} alt="avater" />
//                       </button>
//                     </SwiperSlide>
//                   ))}
//                 </Swiper>
//               </div>

//               <div className="testi-shape"></div>

//               {/* === Main slider === */}
//               <Swiper
//                 id="testId"
//                 // keep original data-* attributes (not used by Swiper, but safe for your theme)
//                 data-slide-show="1"
//                 data-fade="true"
//                 modules={[Autoplay, Thumbs, EffectFade]}
//                 autoplay={{ delay: 4000, disableOnInteraction: false }}
//                 effect="fade"
//                 fadeEffect={{ crossFade: true }}
//                 loop={true}
//                 slidesPerView={1}
//                 thumbs={{ swiper: thumbsSwiper }}
//                 className="vs-carousel testiSlider"
//               >
//                 {testimonials.map(
//                   ({ avatar, quoteImg, rating, text, name, designation }, idx) => (
//                     <SwiperSlide key={idx}>
//                       <div className="position-relative z-index-common">
//                         <div className="testi-quote">
//                           <img src={quoteImg} alt="quote" />
//                         </div>
//                         <div className="testi-rating">
//                           {[...Array(5)].map((_, i) => (
//                             <i
//                               key={i}
//                               className={i < rating ? "fas fa-star" : "far fa-star"}
//                             />
//                           ))}
//                         </div>
//                         <p className="testi-text text-warning">{text}</p>
//                         <div className="testi-avater">
//                           <img src={avatar} alt="customer image" />
//                         </div>
//                         <h3 className="testi-name">{name}</h3>
//                         <span className="testi-degi">{designation}</span>
//                       </div>
//                     </SwiperSlide>
//                   )
//                 )}
//               </Swiper>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TestimonialSection;







import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Desai',
    role: 'Frequent Traveller',
    text: 'Platinum24 Cabs is always on time and the cars are super clean. I use them regularly for airport drops and have never been disappointed.',
    rating: 5,
    avatar: '/img/testimonial/avater-1-1.jpg'
  },
  {
    id: 2,
    name: 'Miss. Sonal Rane',
    role: 'Marketing Executive',
    text: 'Excellent service! The driver was polite, the cab was comfortable, and the Pune to Mumbai ride was smooth and hassle-free.',
    rating: 4,
    avatar: '/img/testimonial/avater-1-2.jpg'
  },
  {
    id: 3,
    name: 'Mr. Rahul Patil',
    role: 'Entrepreneur',
    text: 'Booked a weekend ride to Lonavala. The booking process was easy, and the cab arrived right on time. Highly recommended!',
    rating: 5,
    avatar: '/img/testimonial/avater-1-3.jpg'
  },
  {
    id: 4,
    name: 'Miss. Priya Mehta',
    role: 'Software Engineer',
    text: 'Professional service with transparent pricing. Platinum24 Cabs has become my go-to for all intercity travel needs.',
    rating: 5,
    avatar: '/img/testimonial/avater-1-4.jpg'
  },
];

const TestimonialSection = () => {
  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    arrows: false,
    fade: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <section className="space testimonial-style1" style={{ backgroundImage: "url('/img/bg/testimonial-bg.jpg')" }}>
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-xxl-5 col-xl-5">
            <div className="title-area">
              <span className="sec-subtitle text-white">Platinum24 Cabs</span>
              <h2 className="sec-title h1">What Our Customers Say</h2>
              <p className="sec-text">
                Trusted by hundreds of happy travelers across Maharashtra. Hear how Platinum24 Cabs makes every ride reliable, safe, and stress-free.
              </p>
              <a href="/booking" className="vs-btn style3">Book a Ride</a>
            </div>
          </div>

          <div className="col-xxl-6 col-xl-7">
            <div className="testi-style1">
              <div className="testi-avaters vs-slider-tab">
                {testimonials.map((item) => (
                  <button key={item.id} className="tab-btn">
                    <img src={item.avatar} alt="avater" />
                  </button>
                ))}
              </div>

              <div className="testi-shape"></div>

              <Slider {...sliderSettings}>
                {testimonials.map((item) => (
                  <div className="position-relative z-index-common" key={item.id}>
                    <div className="testi-quote">
                      <img src="/img/shape/quote1.png" alt="quote" />
                    </div>

                    <div className="testi-rating">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={i < item.rating ? "fas fa-star" : "far fa-star"}></i>
                      ))}
                    </div>

                    <p className="testi-text">{item.text}</p>

                  

                    <h3 className="testi-name">{item.name}</h3>
                    <span className="testi-degi">{item.role}</span>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
